var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-manager-element-item-wrapper"
    },
    [
      !_vm.sortChapters
        ? _c(
            "a",
            {
              staticClass: "cw-manager-element-item",
              class: [_vm.inserter ? "cw-manager-element-item-inserter" : ""],
              attrs: {
                href: "#",
                title: _vm.elementTitle
              },
              on: {
                click: _vm.clickItem
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.element.attributes.title) +
                  "\n            "
              ),
              _vm.task
                ? _c(
                    "span",
                    {
                      staticClass: "cw-manager-element-item-solver-name"
                    },
                    [_vm._v("| " + _vm._s(_vm.solverName))]
                  )
                : _vm._e()
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "cw-manager-element-item cw-manager-element-item-sorting"
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.element.attributes.title) +
                  "\n        "
              ),
              _vm.sortChapters
                ? _c(
                    "div",
                    {
                      staticClass: "cw-manager-element-item-buttons"
                    },
                    [
                      _c(
                        "button",
                        {
                          attrs: {
                            disabled: !_vm.canMoveUp,
                            title: _vm.$gettext("Element nach oben verschieben")
                          },
                          on: {
                            click: _vm.moveUp
                          }
                        },
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "arr_2up",
                              role: "sort"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          attrs: {
                            disabled: !_vm.canMoveDown,
                            title: _vm.$gettext(
                              "Element nach unten verschieben"
                            )
                          },
                          on: {
                            click: _vm.moveDown
                          }
                        },
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "arr_2down",
                              role: "sort"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }